import { render, staticRenderFns } from "./mv.vue?vue&type=template&id=351a3d2c&"
import script from "./mv.vue?vue&type=script&lang=js&"
export * from "./mv.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports